import "./HelpButton.less";

import { GuxIcon, GuxTooltip } from "genesys-spark-components-react";
import strings from "./HelpButton.strings";
import { useStrings } from "features/i18n/useStrings";

export function HelpButton({ helpText = undefined }: { helpText?: string }) {
    const t = useStrings(strings);

    return helpText ? (
        <div className="help-text" tabIndex={0}>
            <GuxIcon
                icon-name="fa/circle-question-regular"
                screenreaderText={t.labels.helpText({ helpText })}
            />
            <GuxTooltip placement="bottom-end">
                <span slot="content" aria-hidden="true">
                    {helpText}
                </span>
            </GuxTooltip>
        </div>
    ) : null;
}
